import React from 'react'

export const MediaBoxEmptyRow = props => {
    return (
        <div className="media text-muted pt-3 pointer"><p className="media-body pb-3 mb-0 small lh-125 border-gray">{props.text}</p></div>
    );
}